<template>
  <SogForm>
    <SogFormField width="200px">
      <SogNumericTextBox
        ref="_eCount"
        v-model="_count"
        placeholder="Anzahl"
        format="n"
        width="150px"
        :min="1"
      />
      <SogTextBox
        ref="_ePrefix"
        v-model="_prefix"
        placeholder="Prefix"
        width="150px"
      />
      <SogNumericTextBox
        ref="_eStartNumber"
        v-model="_startNumber"
        placeholder="Startnummer"
        format="n"
        width="150px"
        :min="1"
      />
      <SogNumericTextBox
        ref="_eDigitCount"
        v-model="_digitCount"
        placeholder="Anzahl Ziffern"
        format="n"
        width="150px"
        :min="1"
      />
    </SogFormField>
    <SogFormField>
      {{ _sample }}
    </SogFormField>
  </SogForm>
</template>

<script setup lang="ts">
import {ref} from "vue";
import SogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogNumericTextBox from "@/shared/ui/SogNumericTextBox.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import {computed} from "vue";
import {fillNumberWithZeros} from "@/shared/utils/NumberUtils";


const _prefix = ref("AV")
const _startNumber = ref(1)
const _digitCount = ref(7)
const _count = ref(1)

const _sample = computed(() => {
  const t_start = fillNumberWithZeros(_startNumber.value, _digitCount.value)
  const t_end = fillNumberWithZeros((_startNumber.value + _count.value - 1), _digitCount.value)
  return _prefix.value + t_start + " - " + _prefix.value + t_end
})

function getResults(): { prefix: string, startNumber: number, digitCount: number, count: number } {
  return {prefix: _prefix.value, startNumber: _startNumber.value, digitCount: _digitCount.value, count: _count.value};
}

defineExpose({
  getResults
})

</script>

<style>

</style>
